function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Checklist = function Checklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M1.24 4.91a3.08 3.08 0 0 0 3.08 3.07c1.7 0 3.08-1.37 3.08-3.07S6.02 1.83 4.32 1.83 1.24 3.22 1.24 4.91m1.5 0c0-.87.71-1.58 1.58-1.58s1.58.72 1.58 1.58a1.581 1.581 0 0 1-3.16 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M3.15 21.95c.14.14.35.19.53.22v-.01c.2 0 .39-.08.53-.22l2.71-2.69c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-2.18 2.16-.92-.93a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M4.32 15.56c-1.7 0-3.08-1.38-3.08-3.08s1.38-3.07 3.08-3.07 3.08 1.38 3.08 3.07-1.38 3.08-3.08 3.08m0-4.64c-.87 0-1.58.71-1.58 1.57s.71 1.58 1.58 1.58 1.58-.71 1.58-1.58-.71-1.57-1.58-1.57",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M10.91 5.66h11.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11.1c-.41 0-.75.34-.75.75s.34.75.75.75M22.01 13.24h-11.1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h11.1c.41 0 .75.34.75.75s-.34.75-.75.75M10.91 20.82h11.1c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11.1c-.41 0-.75.34-.75.75s.34.75.75.75"
  }));
};
export default Checklist;
Checklist.displayName = 'Checklist';